import http from '@/plugins/http';
import { useCompanyStore } from '@/stores/company';
import { useCustomerKpiStore } from '@/stores/customerKpi';
import DataService from '../data';

export default (studentId, token, params) => new Promise((res, rej) => {
  const softskills = params.softskills ? params.softskills.map((item) => (item.id)) : [];

  const data = {
    score: params.score,
    soft_skill_id_array: softskills,
    comment: params.comment,
    user_job_id: params.user_job_id,
    token,
  };

  http.post(`v3/students/${studentId}/soft-skills-notation `, data)
    .then((response) => {
      const results = response.status;
      // SP-14862 — same scope as the sidebar counter: the stats endpoint is scoped by
      // the id in its URL, so refresh the badge for the SELECTED account.
      const selectedCompany = useCompanyStore().currentCompany;
      if (selectedCompany) {
        DataService.customerKpi(selectedCompany.id)
          .then((resp) => {
            useCustomerKpiStore().countStudentsToRate(resp.studentsKpi.nbStudentsToRate);
          })
          .catch((error) => {
            // SP-14582 — refreshing the badge is best effort: never turn it into an
            // unhandled rejection (the notation itself already resolved).
            window.console.warn('updateStudentSoftskills: customer KPI refresh failed', error && error.message);
          });
      }
      useCustomerKpiStore().refreshAccountsKpi();
      res(results);
    })
    .catch((error) => {
      rej(error);
    });
});
